import { SidebarPortal } from "@/features/Navigation/components/SidebarPortal";
import { showCompanyListAtom } from "../CompaniesLayout";
import { useAtomValue } from "jotai";
import clsx from "clsx";
import { motion } from "framer-motion";
import { RightDrawerContent } from "@/features/Navigation/components/RightDrawerContent";
import { FileView } from "@/features/Labeling/components/FileView/FileView";
import { FileHeading } from "@/features/Labeling/components/FileHeading";
import { LabelingEmptyState } from "@/features/Labeling/components/LabelingEmptyState";
import { useLabelingEmptyState } from "@/features/Labeling/hooks/useLabelingEmptyState";
import { rightDrawerOpenAtom } from "@/features/Navigation/state";
import { LabelingContextPanel } from "@/features/Labeling/panels/LabelingContextPanel";
import { useLabelingHydration } from "@/features/Labeling/hooks/useLabelingHydration";
import {
    draftAtom,
    labelingParamsAtom,
    tasksAtom,
} from "@/features/Labeling/state";
import { TaskStatus } from "@/entities/DataAssociation/Task.model";
import { useEffect } from "react";
import { useRouter } from "@/utils";
import { FileListV2 } from "@/features/Labeling/components/FileListV2/FileListV2";

export default function LabelingUI() {
    useLabelingHydration();
    useLabelingEmptyState();
    const showCompanyList = useAtomValue(showCompanyListAtom);
    const { selectedFileId } = useAtomValue(labelingParamsAtom);
    const drawerIsOpen = useAtomValue(rightDrawerOpenAtom);
    const tasks = useAtomValue(tasksAtom);
    const draft = useAtomValue(draftAtom);
    const router = useRouter();
    const isReadonly = !router.params.draftId;

    useEffect(() => {
        const finishedTask = tasks.data?.find(
            (task) => task.status === TaskStatus.Completed,
        );
        if (finishedTask) {
            router.navigate(
                `/beta/companies/${router.params.companyId}/labeling/files/${finishedTask.resultFileId}`,
            );
        }
    }, [tasks.data, router.params.companyId, router.navigate]);

    return (
        <>
            <div>
                {!showCompanyList && (
                    <SidebarPortal>
                        <FileListV2 />
                    </SidebarPortal>
                )}

                {drawerIsOpen && (
                    <RightDrawerContent>
                        <LabelingContextPanel />
                    </RightDrawerContent>
                )}
            </div>
            <motion.div className="flex size-full">
                <div
                    className={clsx("size-full px-6", "flex flex-col", "gap-3")}
                >
                    {!selectedFileId && <LabelingEmptyState />}
                    {!isReadonly && !draft.data && draft.isError && (
                        <div>
                            Draft 404 - Check if draft was converted to a
                            labeled file
                        </div>
                    )}
                    <FileHeading />
                    <FileView />
                </div>
            </motion.div>
        </>
    );
}
